import './class-components-hooks';
import Vue from "vue";
import i18n from './i18n';
import '@/locale';
import App from './App.vue';
import router from './router';
import store from './store';

import VueTabs from "vue-nav-tabs/dist/vue-tabs.js";
import { SliderPlugin } from "@syncfusion/ej2-vue-inputs";
import vSelect from 'vue-select';

import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import hcMore from 'highcharts/highcharts-more';
import hcExporting from 'highcharts/modules/exporting';
import hcSolidGauge from 'highcharts/modules/solid-gauge';
import hcColorAxis from 'highcharts/modules/coloraxis';
import darkUnica from 'highcharts/themes/dark-unica';
import VueGtm from '@gtm-support/vue2-gtm';

import { initalizeGoogleMaps } from '@/services/maps'; 

Vue.config.productionTip = false;
Vue.use(VueTabs);
Vue.use(SliderPlugin);
Vue.component('v-select', vSelect);


darkUnica(Highcharts);
hcMore(Highcharts);
hcExporting(Highcharts);
hcColorAxis(Highcharts);
hcSolidGauge(Highcharts)
Vue.use(HighchartsVue);
Vue.use(VueGtm, {
  id: 'GTM-PTV9CBR', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: process.env.NODE_ENV!=="production", // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

initalizeGoogleMaps(() => {});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
